<span *ngIf="!hasAiData">{{ currency }} <span class="negative-amount" *ngIf="showNegative">-</span> {{ amount | number:'1.2-2' }}</span>
<span *ngIf="hasAiData && matches" class="ai-verified-badge ai-match">
  <i class="far fa-brain-circuit"></i> {{ currency }} {{ amount | number:'1.2-2' }}
</span>
<span *ngIf="hasAiData && !matches" class="ai-verified-badge ai-mismatch" [attr.data-tooltip]="mismatchReason">
  <i class="far fa-brain-circuit"></i> {{ currency }} {{ amount | number:'1.2-2' }}
</span>
